<script>
export default {
  props: {
    headerTitle: { type: String, default: '' },
    headerContent: { type: String, default: '' },
  },
};
</script>

<template>
  <div
    class="mb-5 flex w-full flex-col items-start gap-1.5 border-b border-auth-border pb-4 dark:border-auth-border-dark"
  >
    <h2
      class="break-words text-xl font-semibold tracking-tight text-auth-text dark:text-auth-text-dark"
    >
      {{ headerTitle }}
    </h2>
    <p
      v-dompurify-html="headerContent"
      class="w-full max-w-[75ch] text-body-main text-auth-muted dark:text-auth-muted-dark"
    />
  </div>
</template>
